const customDropzoneStyles = {
  dropzone: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    border: "2px dashed #CBD0DC",
    textAlign: "center",
    transition: "border-color 0.3s",
    borderRadius: "26px",
  },
  dragover: {
    borderColor: "#aaa",
  },
  dropzoneText: {
    color: "#475569",
    // fontSize: "1.25rem",
    fontWeight: 500,
  },
  acceptedFilesText: {
    color: "#A9ACB4",
    // fontSize: "0.775rem",
    fontWeight: 500,
    textAlign: "left",
  },
  greyBox: {
    margin: "1%",
  },
};

export default customDropzoneStyles;
